import React from "react";

let onClick = (e, props) => {
  e.preventDefault();
  console.log("onclick..", e.target.className, props);
};
function NavItem(props) {
  return (
    <li className="nav-item">
      <a
        className="nav-link"
        href="#"
        onClick={onClick}
        data-scroll-nav={props.navId}
      >
        {props.navName}
      </a>
    </li>
  );
}

export default NavItem;
